import { forwardRef, ReactNode } from 'react';
import { useField } from 'formik';
import ReactQuill from 'react-quill-new';

import FormGroup from './FormGroup';
import RichText from './RichText';

type Props = {
  label?: ReactNode;
  labelFor?: string;
  name: string;
  onBlur?: () => void;
  onFocus?: () => void;
  tooltip?: string;
};

const FormRichText = forwardRef<ReactQuill, Props>(function FormRichText(
  { label, labelFor, name, onBlur, onFocus, tooltip },
  ref,
) {
  const [field, meta, helpers] = useField<string>(name);
  const hasError = !!(meta.touched && meta.error);

  return (
    <FormGroup
      error={hasError ? meta.error : ''}
      label={label}
      labelFor={labelFor}
      tooltip={tooltip}
    >
      <RichText
        ref={ref}
        onBlur={onBlur}
        onChange={(content) => helpers.setValue(content)}
        onFocus={onFocus}
        value={field.value ?? ''}
      />
    </FormGroup>
  );
});

export default FormRichText;
